module.exports = __webpack_public_path__ + "img/hand-middle-finger.d607a1e7.svg";